export default __webpack_public_path__ + "static/media/poly.1140771b.png";